// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, type IntlShape } from 'react-intl';

import type { Dispatch } from 'state/types';
import { bindActionCreatorsSafe } from 'util/safeDispatch';
import localizedStrings from 'util/localizedStrings';

import {
  rtiToggle as rtiToggleCommand,
  getRTI as getRTICommand,
} from 'state/commands/rtiCommands';
import { getRTIEnabled } from 'state/selectors';

type Props = {
  getRTICommand: typeof getRTICommand,
  intl: IntlShape,
  rtiEnabled: boolean,
  rtiToggleCommand: typeof rtiToggleCommand,
};

type State = {
  isWaitingForResponse: boolean,
};

class AnalyticsPage extends Component<Props, State> {
  handleRTIToggle: Function;
  handleHelpClick: Function;

  state = { isWaitingForResponse: false };

  constructor() {
    super();
    this.handleRTIToggle = this.handleRTIToggle.bind(this);
    this.handleHelpClick = this.handleHelpClick.bind(this);
  }

  componentDidMount() {
    this.getRTI();
  }

  async getRTI() {
    await this.props.getRTICommand();
  }

  handleHelpClick() {
    const { formatMessage } = this.props.intl;
    const url = formatMessage(localizedStrings.DATA_COLLECTION_HELP_URL);
    window.open(url, '_blank');
  }

  async handleRTIToggle() {
    this.setState({ isWaitingForResponse: true });
    await this.props.rtiToggleCommand(!this.props.rtiEnabled);
    await this.getRTI();
    this.setState({ isWaitingForResponse: false });
  }

  render() {
    const { rtiEnabled } = this.props;
    const { isWaitingForResponse } = this.state;
    const checkboxClass = isWaitingForResponse
      ? 'rti-checkbox-hide'
      : 'rti-checkbox-show';

    return (
      <div
        className="page-contents columns is-gapless"
        data-test-name="analytics-page"
      >
        <div className="column">
          <header className="page-header">
            <FormattedMessage {...localizedStrings.DATA_COLLECTION_TITLE} />
          </header>
          <section className="section page-contents-textured portfolio-form-container rti-opt-out">
            <div className="box">
              {/* spinner */}
              <div
                className="control is-small is-loading is-pulled-left"
                style={{
                  right: '-38px',
                  top: '1px',
                  display: isWaitingForResponse ? '' : 'none',
                }}
              />
              <input
                className={`is-checkradio is-medium ` + checkboxClass}
                id="rtiEnabled"
                data-test-name="rti-enabled"
                type="checkbox"
                checked={rtiEnabled}
                onChange={this.handleRTIToggle}
              />
              <label htmlFor="rtiEnabled">
                <FormattedMessage
                  {...localizedStrings.DATA_COLLECTION_RTI_OPT_OUT_LABEL}
                />
              </label>
              <div style={{ marginTop: '36px' }}>
                <FormattedMessage
                  {...localizedStrings.DATA_COLLECTION_RTI_OPT_OUT_TEXT}
                />{' '}
                <a onClick={this.handleHelpClick}>
                  <FormattedMessage
                    {...localizedStrings.DATA_COLLECTION_HELP_URL}
                  />
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    rtiEnabled: getRTIEnabled(state),
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsSafe({
      rtiToggleCommand,
      getRTICommand,
    })
)(injectIntl(AnalyticsPage));



// WEBPACK FOOTER //
// ./src/view/Pages/AnalyticsPage.js